import { getInfo, login } from '@/api/auth/auth' // getQywxAppId getCorpSecret
import { getCountItem } from '@/api/admi/user'
import { getToken, setToken } from '@/utils/auth'
const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    permissions: [],
    count: '',
    oneminute: 60
  }
}
let userInfo = ''
const state = getDefaultState()

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  SET_USERINFO: (state, user) => {
    state.user = user
  },
  SET_COUNT: (state, count) => {
    state.count = count
  },
  SET_ONEMINUTE: (state, oneminute) => {
    state.oneminute = oneminute
  }
}
const actions = {

  // 授权获取code
  async GetCode({ commit }) {
    // const loginInfo = await getQywxAppId(1)
    // const appid = loginInfo.data.corpId
    // const scope = 'snsapi_privateinfo'
    // const agentid = loginInfo.data.agentId
    // const corpSecret = loginInfo.data.corpSecret
    const appid = process.env.VUE_APP_WX_APPID
    const scope = process.env.VUE_APP_WX_SCOPE
    // const hrefIdx = window.location.href.indexOf('agentId=')
    // const agentid = window.location.href.slice(hrefIdx + 8)
    const agentid = process.env.VUE_APP_WX_AGENTID
    // const corpSecret = process.env.VUE_APP_WX_CORPSECRET
    // const redirect_uri = "https://crm.data.tryine.com"
    const redirectUri = window.location.href
    const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&agentid=${agentid}&state=STATE#wechat_redirect`
    window.location.replace(url)
  },

  // 登录
  async Login({ commit }, code) {
    const appid = process.env.VUE_APP_WX_APPID
    const corpSecret = process.env.VUE_APP_WX_CORPSECRET
    // const corpSecret = await getCorpSecret(agentid)
    // let corpSecret = ''
    // const hrefIdx = window.location.href.indexOf('agentId=')
    // const hrefIdx2 = window.location.href.indexOf('&code=')
    // const agentid = window.location.href.slice(hrefIdx + 8, hrefIdx2)
    // if (agentid == 1000115) {
    //   corpSecret = 'kbjeD6Or9Cw-PIQk2XffcDnMfMk0lIZ-3LxnQCXKAIc'
    // } else if (agentid == 1000144) {
    //   corpSecret = 'yvjjF19Dz6xgl6_7SkC9FhC8oPS-xTqk2Ys_7GTly24'
    // } else if (agentid == 1000145) {
    //   corpSecret = 'G99mIaqG9WsnV3Z0_rOLb-Z0X8F_MKLJRkfBuu1K2p4'
    // } else if (agentid == 1000029) {
    //   corpSecret = '6tMissdtG9TBwbYXTbZv0bEdZlZmr2LFdfHM8c1zp5Y'
    // }
    // await getCorpSecret(agentid).then(res => {
    //   corpSecret = res.data.wxSecret
    // })
    return new Promise((resolve, reject) => {
      login({
        corpid: appid,
        corpsecret: corpSecret,
        code: code
      })
        .then(res => {
          if (res.code === 200) {
            setToken(res.token)
            commit('SET_TOKEN', res.token)
          }
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取用户信息
  async GetInfo({ commit }) {
    const res = await getInfo()
    const user = res.user
    userInfo = res.user
    if (res.roles && res.roles.length > 0) {
      console.log('用户信息', res)
      // 验证返回的roles是否是一个非空数组
      commit('SET_ROLES', res.roles)
      commit('SET_PERMISSIONS', res.permissions)
      commit('SET_USERINFO', res.user)
    } else {
      commit('SET_ROLES', ['ROLE_DEFAULT'])
    }
    commit('SET_NAME', user.userName)
  },

  // 获取待办总数
  async GetDbCount({ commit }) {
    // const res = await getInfo()
    // const user = res.user
    const query = {
      backlogType: null,
      checkStatus: 0,
      userId: null,
      childType: null
    }
    if (userInfo.roles.length > 0) {
      if (userInfo.roles.some(item => { return item.roleKey === 'CONT_CWQR' })) {
        query.userId = null
        let number = ''
        const res01 = await getCountItem({ ...query, backlogType: 3 })
        if (res01.code == 200) {
          number = res01.data
        }
        const res2 = await getCountItem({ ...query, backlogType: 4, childType: 6 })
        if (res2.code == 200) {
          number.khCount += res2.data.khCount
          number.htCount += res2.data.htCount
          number.skCount += res2.data.skCount
          number.dkCount += res2.data.dkCount
          commit('SET_COUNT', number.khCount + number.htCount + number.skCount + number.dkCount)
        }
      } else {
        query.userId = userInfo.userId
        const res02 = await getCountItem({ ...query, backlogType: null, childType: null })
        if (res02.code == 200) {
          commit('SET_COUNT', res02.data.khCount + res02.data.htCount + res02.data.skCount + res02.data.dkCount)
        }
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
